import React from "react";
import { Button as ReactButton } from "reactstrap";
import PropTypes from "prop-types"
import {BUTTON_COLORS} from "./appearance";

const Button = ({
  id,
  type = "button",
  color,
  onClick,
  ref,
  disabled,
  size = "",
  wavesEffect = "",
  wavesLight = "",
  block = "",
  rounded = "",
  children,
  className,
  outline,
}) => {
  const classes = `${block} ${wavesEffect} ${wavesLight} ${rounded} ${className}`;

  return (
    <ReactButton
      id={id}
      type={type}
      className={classes}
      color={color}
      onClick={onClick}
      innerRef={ref}
      disabled={disabled}
      size={size}
      ref={ref}
      outline={outline}
    >
      {children}
    </ReactButton>
  );
};

Button.propTypes = {
  id: PropTypes.string,
  type: PropTypes.oneOf(["button", "submit"]),
  color: PropTypes.oneOf(Object.values(BUTTON_COLORS)),
  block: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func,
  ref: PropTypes.any,
  disabled: PropTypes.bool,
  children: PropTypes.any,
  rounded: PropTypes.string,
  wavesEffect: PropTypes.string,
  wavesLight: PropTypes.string
};


export default Button
